const truthyValues = new Set([true, "true", "True", "1", 1]);

export const isAdminUser = (user) => {
  if (!user) return false;
  if (truthyValues.has(user.is_superuser) || truthyValues.has(user.is_staff) || truthyValues.has(user.is_admin)) {
    return true;
  }
  const role = typeof user.role === "string" ? user.role.toLowerCase() : "";
  return role === "admin" || role === "superuser" || role === "staff";
};
